import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../../../hooks'
import Text from '../../../../../Text'
import { QA_NAME_INTEGRATIONS_PANEL_FACT } from '../../RentalPortalIntegrationsPanel.constants'
import { getIntegrationsPanelFactValue } from '../../RentalPortalIntegrationsPanel.utils'

import * as styles from './IntegrationsPanelFact.module.css'

function IntegrationsPanelFact({ connection, fact: { labelKey, name } }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  return (
    <>
      <Text isSecondary className={styles.text}>
        {t(labelKey)}
      </Text>
      <Text
        className={styles.text}
        qaName={`${QA_NAME_INTEGRATIONS_PANEL_FACT}_${name}`}
      >
        {getIntegrationsPanelFactValue({ connection, locale, name, timezone })}
      </Text>
    </>
  )
}

export default IntegrationsPanelFact
